<mtn-key-value [key]="key | translate" [alignment]="alignment" [keyWidthPercent]="keyWidthPercent"
               [whatIsThisText]="whatIsThisText | translate">
  <div *ngIf="!isUndefined; else notAvailable">{{ value }}</div>
  <ng-template #notAvailable>
    <div class="color-muted">{{ 'NOT_AVAILABLE' | translate }}</div>
  </ng-template>
</mtn-key-value>
